module.exports = __webpack_public_path__ + "img/top-left.0052d87d.webp";